<div class="tab-data-container">
	<a
		class="link"
		target="_blank"
		[routerLink]="
			permissionService.hasPermission('access_myasset') ? '/myasset/inconsistency/' + requestData.relatedInconsistency?.id : null
		">
		<div class="inconsistency">
			<span>
				{{ requestData.relatedInconsistency?.id }} -
				{{ labels[requestData.relatedInconsistency?.label] ?? requestData.relatedInconsistency?.label }} -
				{{ labels.lbl_rep_abertos_em }} {{ dateService.formatDate(requestData.relatedInconsistency?.creation_date) }}
			</span>
			<span>
				<fa-icon [icon]="icons.faExternalLinkAlt"></fa-icon>
			</span>
		</div>
	</a>
</div>
